import { ReactNode } from 'react';
import clsx from 'clsx';

import { Border } from './Border';
import { FadeIn, FadeInStagger } from './FadeIn';

/**
 * Configuration properties for the List component.
 */
interface IListProps {
  /** The list items to be rendered. */
  children: ReactNode;
  /** Optional CSS class name. */
  className?: string;
}

/**
 * A list component that staggers the fade-in animations of its items.
 */
export function List({ children, className }: IListProps) {
  return (
    <FadeInStagger>
      <ul className={clsx('text-base text-gray-600', className)}>{children}</ul>
    </FadeInStagger>
  );
}

/**
 * Configuration properties for the ListItem component.
 */
interface IListItemProps {
  /** The content of the list item. */
  children: ReactNode;
  /** Optional title for the list item. */
  title?: string;
}

/**
 * An individual item within a List component.
 */
export function ListItem({ children, title }: IListItemProps) {
  return (
    <li className="group mt-10 first:mt-0">
      <FadeIn>
        <Border className="pt-10 group-first:pt-0 group-first:before:hidden group-first:after:hidden">
          {title ? (
            <strong className="font-semibold text-gray-950">{`${title}. `}</strong>
          ) : null}
          {children}
        </Border>
      </FadeIn>
    </li>
  );
}
